import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CustomErrorStateMatcher } from '../../models/custom-error-state';
import { IItem } from '../../models/group-edit-config';

@Component({
  selector: 'app-input-edit-currency',
  templateUrl: './input-edit-currency.component.html',
  styleUrls: ['./input-edit-currency.component.scss'],
  providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: InputEditCurrencyComponent
    }
  ]
})
export class InputEditCurrencyComponent implements ControlValueAccessor {
    
    @Input() errorState = new CustomErrorStateMatcher();
    localConfig!: IItem;
    @Input() set config(_c : IItem){
        this.localConfig = _c;
    }

    disabled = false;
    constructor() { }


    onChange = (value: number) => {}
    onTouched = () => {}

    //This is the value that is bound to the html control
    localValue: any = 0
    //This is the value we will store and return
    underlyingValue: number = 0;
    //control type needs to switch between number and text
    controlType = 'text';

    writeValue(obj: any): void {
        console.log("InputEditCurrencyComponent writeValue");
        this.underlyingValue = obj;
        this.controlType = "text";
        this.localValue = formatCurrency(obj);
    }

    focus(){
        console.log("InputEditCurrencyComponent focus");
        this.onTouched();
        this.controlType = "number";
        this.localValue = this.underlyingValue;
    }

    keyUp(e: any) {
        this.localValue = e.target.value;
        this.underlyingValue = parseFloat(this.localValue);
        console.log("InputEditCurrencyComponent blur", this.underlyingValue, this.localValue);
        this.onChange(this.underlyingValue);
        console.log("InputEditCurrencyComponent post onChange");
    }

    blur() {        
        this.controlType = "text";
        this.localValue = formatCurrency(this.underlyingValue);
        console.log("InputEditCurrencyComponent blur", this.underlyingValue, this.localValue);
    }

    registerOnChange(fn: any): void {
        console.log("InputEditCurrencyComponent registerOnChange");
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        console.log("InputEditCurrencyComponent registerOnTouched");
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

}

export const formatCurrency = (num: any, fractionDigits?: number) => {
    const frac = fractionDigits === undefined ?  2: fractionDigits;
    const intl = new Intl.NumberFormat('en-GB',
        {
            style: 'decimal',
            minimumFractionDigits: frac,
            maximumFractionDigits: frac,
        });
    let result = intl.format(Math.abs(num));
    if(num < 0){
        result = `(${result})`;
    }
    return result;
}

